import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { ActivatedRouteSnapshot, Router, CanActivate } from '@angular/router';

@Injectable()
export class RoleGuardService implements CanActivate {

  constructor(public authService: AuthService, public router: Router) {}

  isAuthorized(roles: ('Basic'|'Admin'|'SuperAdmin')[]): boolean {
    const token = this.authService.getDecodedJwtToken();
    const userRoles = token.role || token['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'];

    if (token && userRoles.length) {
        return roles.every((role) => userRoles.includes(role));
    }

    return false;
  }

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const expectedRole = route.data.expectedRole;

    if (!this.isAuthorized([expectedRole])) {
      this.router.navigate(['admin']);
      return false;
    }

    return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/auth/services/role.guard.ts